import React, { useEffect, useRef, useState } from 'react';
import OlMap from 'ol/Map';
import View from 'ol/View';
import OSM from 'ol/source/OSM';
import Vector from 'ol/layer/Vector'
import VectorSource from 'ol/source/Vector'
import TileLayer from 'ol/layer/Tile';
import GeoTIFF from 'ol/source/GeoTIFF.js';
import WebGLTileLayer from 'ol/layer/WebGLTile.js';
import 'ol/ol.css'
import Feature from 'ol/Feature';
import LineString from 'ol/geom/LineString';
import { fromLonLat, toLonLat } from 'ol/proj';
import { Point, Circle, Polygon } from 'ol/geom';
import {circular} from 'ol/geom/Polygon';
import {Fill, Icon, Stroke, Style, Text} from 'ol/style';
import { createEmpty, extend, extendFlatCoordinates, isEmpty, containsCoordinate, boundingExtent } from 'ol/extent';
import { DragBox, defaults as defaultInteractions, Draw, Modify, Snap } from 'ol/interaction';
import {platformModifierKeyOnly} from 'ol/events/condition';
import XYZ from 'ol/source/XYZ';
import { Button, CloseButton, Col, Form, Modal, Row, ToggleButton } from 'react-bootstrap';
import { Overlay } from 'ol';
import {Control, FullScreen, ScaleLine, defaults as defaultControls} from 'ol/control';
import handleError from './handleError';
import circle_red from './images/circle-red.png';
import circle_yellow from './images/circle-yellow.png';
import circle_black from './images/circle-black.png';
import arrow_red from './images/arrow-up-red-tr.png';
import arrow_purple from './images/arrow-up-purple-tr.png';
import arrow_blue from './images/arrow-up-blue-tr.png';
import arrow_yellow from './images/arrow-up-yellow-tr.png';
import arrow_orange from './images/arrow-up-orange-tr.png';
import searchIcon from './images/search.png';
import { buffer } from 'ol/size';
import ImageLayer from 'ol/layer/Image';
import Static from 'ol/source/ImageStatic.js';
// TODO: Think if precise distance is what we always want?
import getDistance from 'geolib/es/getPreciseDistance';
import isPointInPolygon from 'geolib/es/isPointInPolygon'
import spotBeams from './analysis/spotBeams'
import './mapview.css'
import { transformExtent } from 'ol/proj';
import { cyrb128, sfc32 } from './rand';

const SATTELITE_SENSORS = ["Sentinel-2", "Copernicus JPG", "Copernicus", "Satellogic", "Capella-SAR"];

function getJSONs(token, files){
    return fetch("/api/getjsons", {
        method: "POST",
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({token, files})
    })
        .then(data => data.json())
}

function getCSV(token, file){
    return fetch("/api/getcsv", {
        method: "POST",
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({token, file})
    })
        .then(data => data.json())
}

function getShipPorts(token){
    return fetch("/api/getshipports", {
        method: "POST",
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({token})
    })
        .then(data => data.json())
}

function produceShipReport(token, trial_id, port, report){
    return fetch("/api/produceshipreport", {
        method: "POST",
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({token, trial_id, port, report})
    })
}

function getThumbLink(file, size){
    return `https://eapi.pcloud.com/getpubthumb?code=${file.pubcode}&size=${size?size:"32x32"}&crop=1`;
}

function getDist(track1, track2){
    return fetch("/api/calcDist", {
        method: "POST",
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({track1, track2})
    })
        .then(data => data.json())
}

function uploadPoly(token, trial_id, name, type, bufSize, poly, setToken, cb){
    return fetch("/api/uploadpoly", {
        method: "POST",
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({token, trial_id, name, type, bufSize, poly})
    })
        .then(data => data.json())
        .then(data => {
            if (data.err) return handleError(data.err, setToken);
            cb(data.file)
        })
}

function updateLastMap(token, trial_id, lastmap){
    let obj = {token, trial_id, lastmap};
    return fetch("/api/updatemap", {
        method: "POST",
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(obj)
    })
        .then(data => data.json());
}

function queryNominatim(location){
    let url = new URL("https://nominatim.openstreetmap.org/search")
    url.searchParams.append("q", location);
    url.searchParams.append("format", "json");
    url.searchParams.append("limit", 1);
    return fetch(url.href).then(data => data.json())
}

function track(cb){
    let host = window.location.host === 'localhost:3000' ? 'localhost:3001' : window.location.host;
    let url = `${window.location.protocol==='https:' ? 'wss' : 'ws'}://${host}/api/geosubscribe`;
    const ws = new WebSocket(url);
    cb(ws)
}

function aisWebSocket(){
    let host = window.location.host === 'localhost:3000' ? 'localhost:3001' : window.location.host;
    let url = `${window.location.protocol==='https:' ? 'wss' : 'ws'}://${host}/api/aisstream`;
    return new WebSocket(url);
}

function hashCode(str) {
    var hash = 0, i, chr;
    if (str.length === 0) return hash;
    for (let i = 0; i < str.length; i++) {
        chr   = str.charCodeAt(i);
        hash  = ((hash << 5) - hash) + chr;
        hash |= 0; // Convert to 32bit integer
    }
    return hash;
};

function fileExt(filename){
    return filename.split('.').pop();
}

function isImage(filename){
    return ["jpg", "jpeg", "png", "JPG", "JPEG", "PNG"].includes(fileExt(filename))
}

function pickHex(color1, color2, weight) {
    var w1 = weight;
    var w2 = 1 - w1;
    var rgb = [Math.round(color1[0] * w1 + color2[0] * w2),
        Math.round(color1[1] * w1 + color2[1] * w2),
        Math.round(color1[2] * w1 + color2[2] * w2)];
    return rgb;
}

/*function colorOnPoll(measurements, a){
    if (!measurements?.pm025) return 'rgba(0, 0, 0, 0)';
    if (measurements.pm025 < 25){ 
        let rgb = pickHex([0, 200, 200], [255, 255, 0], measurements.pm025/25)
        return `rgba(${rgb[0]}, ${rgb[1]}, ${rgb[2]}, ${a})`;
    }
    if (measurements.pm025 < 80){ 
        let rgb = pickHex([255, 255, 0], [255, 0, 0], (measurements.pm025-25)/55)
        return `rgba(${rgb[0]}, ${rgb[1]}, ${rgb[2]}, ${a})`;
    }
    if (measurements.pm025 < 120){ 
        let rgb = pickHex([255, 0, 0], [255, 0, 255], (measurements.pm025-80)/40)
        return `rgba(${rgb[0]}, ${rgb[1]}, ${rgb[2]}, ${a})`;
    }
    return `rgba(255, 0, 255, ${a})`;
}*/
function colorOnPoll(measurements, a){
    if (!measurements?.aqi) return 'rgba(0, 0, 0, 0)';
    if (measurements.aqi < 0){
        return `rgba(0, 0, 0, ${a})`;
    }
    if (measurements.aqi < 50){ 
        return `rgba(0, 255, 0, ${a})`;
    }
    if (measurements.aqi < 100){ 
        return `rgba(255, 255, 0, ${a})`;
    }
    if (measurements.aqi < 150){ 
        return `rgba(255, 165, 0, ${a})`;
    }
    if (measurements.aqi < 200){ 
        return `rgba(255, 0, 0, ${a})`;
    }
    if (measurements.aqi < 300){ 
        return `rgba(106, 13, 173, ${a})`;
    }
    return `rgba(128, 0, 0, ${a})`;
}

function getTime(filename){
    return filename.split('_').pop().split('.')[0]
}

function getDash(source){
    if (source === 1) return [0, 40];
    if (source === 2) return [0, 40];
    if (source === 3) return [0, 40];
    if (source === 4) return [10, 10];
    if (source === 5) return [0, 40];
    if (source === 6) return [0, 40];
}


// TODO: Is declaring Maps here actually useful? Read more about react.
let shipOverlays = new Map();
let shipPositions = new Map();

let segmentedPorts = new Map();
function segmentedKey(lon, lat) {
    //We seperate in chunks of 1 deg by 1 deg
    return `${Math.floor(lon)},${Math.floor(lat)}`
}
function getSegmentedPorts(lon, lat) {
    let ports = []
    for (let dx of [-1, 0, 1]) {
        for (let dy of [-1, 0, 1]) {
            let current_ports = segmentedPorts.get(segmentedKey(lon + dx, lat + dy));
            ports = ports.concat(current_ports === undefined ? [] : current_ports)
        }
    }
    return ports
}
function addSegmentedPort(port) {
    let lat = port["Latitude"]
    let lon = port["Longitude"]
    let boundary = port["boundary"]
    let rad = 5000, color = "grey";
    let name = port["Main Port Name"];
    if (port["Harbor Size"] === "Large") { rad = 10000; color = "purple" }
    if (port["Harbor Size"] === "Medium") { rad = 8000; color = "blue" }
    if (port["Harbor Size"] === "Small") { rad = 6000; color = "yellow" }
    if (port["Harbor Size"] === "Very Small") { rad = 4000; color = "orange" }
    let key = segmentedKey(lon, lat)
    let ports = segmentedPorts.get(key)
    ports = ports === undefined ? [] : ports
    ports.push({ lat, lon, rad, color, boundary, name })
    segmentedPorts.set(key, ports)
}

const view_projection = "EPSG:3857";

export default function MapView({token, setToken, reload, trial_id, trial, files, checked, setChecked}){

    const [base, setBase] = useState("osm");
    const [map, setMap] = useState()
    const [osm, setOsm] = useState()
    const [sat, setSat] = useState()
    const [gpxLayer, setGpxLayer] = useState()
    const [gpxVisible, setGpxVisible] = useState(true)
    //todo: multiple static layers
    const [staticLayers, setStaticLayers] = useState()
    const [imagesLayer, setImagesLayer] = useState()
    const [overlays, setOverlays] = useState()
    const [imagesVisible, setImagesVisible] = useState(true)
    const [airLayer, setAirLayer] = useState()
    const [airLayerVisible, setAirLayerVisible] = useState(true)
    const [airTime, setAirTime] = useState()
    const [airstations, setAirstations] = useState([])
    const [firstAir, setFirstAir] = useState(true);
    const [visLayer, setVisLayer] = useState();
    const [visualizations, setVisualizations] = useState([])
    const [boxLayer, setBoxLayer] = useState();
    const [haveBox, setHaveBox] = useState(false);
    const [drawnLayer, setDrawnLayer] = useState();
    const [trackedLayer, setTrackedLayer] = useState()
    const [trackedLatLon, setTrackedLatLon] = useState()
    const [trackedSocket, setTrackedSocket] = useState()
    const [draw, setDraw] = useState()
    const [modify, setModify] = useState()
    const [snap, setSnap] = useState()
    const [isDrawing, setIsDrawing] = useState(false);
    const [hasDrawn, setHasDrawn] = useState(false);
    // popups
    const [isGeofencePopupVisible, setIsGeofencePopupVisible] = useState(false);
    const [isRegionPopupVisible, setIsRegionPopupVisible] = useState(false);
    //const [gpxLayer, setGpxLayer] = useState(new Vector({source: new VectorSource()}))
    const [shipSocket, setShipSocket] = useState();
    const [showDetailsForShip, setShowDetailsForShip] = useState()
    const [showSpotBeams, setShowSpotBeams] = useState(false)
    const [numSpotBeams, setNumSpotBeams] = useState()
    const [spotBeamRad, setSpotBeamRad] = useState()
    const [spotBeamsLayer, setSpotBeamsLayer] = useState()
    const [shipsCoveredMessage, setShipsCoveredMessage] = useState([])

    const [portsLayer, setPortsLayer] = useState();
    const [ports, setPorts] = useState([])
    const [portDetails, setPortDetails] = useState(undefined);
    const [portDetailedInfo, setPortDetailedInfo] = useState(undefined);
    const [displayPortDetails, setDisplayPortDetails] = useState(false);
    const [showPorts, setShowPorts] = useState("none")

    const [wellsLayer, setWellsLayer] = useState();
    const mapElement = useRef()

    let common_colors=["#ffff00","#00ffff","#a5722a","#ff8000","#ff0ff0","#ff0000","#600080","#0000ff","#999999","#330000","#ffcce5","#9400d3","#c3268a","#b92f2f","#ffa500","#ff6767","#6495ed","#ffd700","#39ff14"]

    function getReadableColor(){
        return base === "osm" ? "black" : "white";
    }
    
    function getAirFeatures(airpoll){
        return airpoll.metadata.map(station => {
            let feature = new Feature({
                geometry: new Circle(fromLonLat([station.lng, station.lat]), 200)
            })
            feature.setStyle(
                new Style({
                    fill: new Fill({
                        color: colorOnPoll(station.measurements, 0.5)
                    }),
                    stroke: new Stroke({
                        color:station.source===4 ? getReadableColor() : 'rgba(0, 0, 0, 0)',
                        width:2
                    })
                })
            )
            return feature;
        })
    }

    function getVisFeatures(vis){
        return vis.metadata.map(obj => {
            if (obj.type==="point"){
                let feature = new Feature({
                    geometry: new Circle(fromLonLat([obj.longitude, obj.latitude]), 20)
                })
                feature.setStyle(
                    new Style({
                        fill: new Fill({color:"black"})
                    })
                )
                return feature;
            }
            if (obj.type==="circle"){
                let feature = new Feature({
                    geometry: new Circle(fromLonLat([obj.longitude, obj.latitude]), obj.radius*3)
                })
                feature.setStyle(
                    new Style({
                        stroke: new Stroke({
                            width: 4,
                            color: obj.color
                        })
                    })
                )
                return feature;
            }
            if (obj.type==="overlay"){
                // TODO: fix this overlay stuff
                // These should be added to the list of overlays instead of added as features.
                // So a more significant change is required here.
                let element = document.createElement("div");
                element.style = "width: 50px; height: 50px";
                let textNode = document.createTextNode(obj.text);
                element.appendChild(textNode);
                let feature = new Overlay({
                    element
                })
                feature.setPosition(fromLonLat([obj.longitude, obj.latitude]));
                return feature;
            }
        })
    }

    function haveTracker(){
        return files
            .filter(f => checked[f.fileid])
            .filter(f => f.sensor === "GeoTracker")
            .length > 0
    }

    function startTracking(){
        let tracker = files
            .filter(f => checked[f.fileid])
            .filter(f => f.sensor === "GeoTracker")[0]
        if (tracker.metadata.trackerId){
            track(ws => {
                ws.onopen = event =>{
                    let geoId = tracker.metadata.trackerId;
                    console.log("subscribing to tracker", geoId);
                    let gpx_files = files.filter(f => checked[f.fileid]).filter(f => (f.sensor === "Output GPX" || fileExt(f.filename) === "gpx") && f.metadata?.track)
                    let buffers = gpx_files.filter(f => f.metadata?.desc === "Buffer").map(f => f.metadata.track)
                    let dangers = gpx_files.filter(f => f.metadata?.desc === "Danger").map(f => f.metadata.track)
                    ws.send(JSON.stringify({geoId, buffers, dangers}))
                }
                ws.onmessage = event => {
                    let latlon = JSON.parse(event.data);
                    setTrackedLatLon(latlon)
                }
                setTrackedSocket(ws);
            })
        }
    }

    /*function getShipFeature(position){
        let feature = new Feature({
            geometry: new Point(fromLonLat([position.Longitude, position.Latitude]), 20)
        })
        let src = circle_black;
        feature.setStyle(
            new Style({
                image: new Icon({src})
            })
        )
        feature.setId(position.UserID)
        return feature
    }
    function modShipFeature(feature, position){
        feature.setGeometry(
            new Point(fromLonLat([position.Longitude, position.Latitude]), 20)
        )
    }*/
    function getShipPort(position){
        let lon = position.Longitude
        let lat = position.Latitude
        let ports = getSegmentedPorts(lon, lat)
        let closest_port;
        let closest_dist = -1;
        for (let port of ports){
            let dist, isIn = false;
            if (port["Main Port Name"] == "Piraievs"){console.log(port)}
            if (port.boundary){
                let polygon = [...port.boundary]
                polygon.pop()
                if(isPointInPolygon({ lon, lat }, polygon)){
                    dist = 0
                    isIn = true
                }
            }else{
                dist = getDistance({ lon, lat }, { lon: port.lon, lat: port.lat })
                isIn = dist < port.rad
            }
            if (isIn){
                if (closest_dist === -1 || closest_dist > dist){
                    closest_dist = dist
                    closest_port = port
                }
            }
        }
        return closest_port;
    }
    function getShipColor(port){
        if (!port || port.color === "red") return arrow_red
        if (port.color === "purple") return arrow_purple
        if (port.color === "blue") return arrow_blue
        if (port.color === "yellow") return arrow_yellow
        if (port.color === "orange") return arrow_orange
    }
    function createShipOverlay(position){
        let MMSI = position.UserID;
        shipPositions.set(MMSI, position)
        let img = document.createElement("img");
        let port = getShipPort(position)
        img.src = getShipColor(port);
        img.title = `MMSI: ${MMSI}`;
        img.style = `
            position: absolute;
            padding: 0px;
            bottom: -10px;
            left: -10px;
            width: 20px;
            height: 20px;
            transform: rotate(${position.TrueHeading === 511 ? 0 : position.TrueHeading}deg);
            z-index: 0;
        `;
        img.onclick = async () => {
            let details = await fetch(`/api/shipdetails/${MMSI}`).then(data => data.json())
            details.Longitude = position.Longitude
            details.Latitude = position.Latitude
            if (port) details.port = port;
            setShowDetailsForShip(details)
        }
        let overlay = new Overlay({
            element: img
        })
        overlay.setPosition(fromLonLat([position.Longitude, position.Latitude]))
        overlay.mmsi = fromLonLat(MMSI);
        shipOverlays.set(MMSI, overlay)
        return overlay;
    }
    function modifyShipOverlay(position){
        let MMSI = position.UserID;
        shipPositions.set(MMSI, position)
        let overlay = shipOverlays.get(MMSI);
        overlay.setPosition(fromLonLat([position.Longitude, position.Latitude]))
        overlay.getElement().style.transform = `rotate(${position.TrueHeading === 511 ? 0 : position.TrueHeading}deg);`
        let port = getShipPort(position)
        overlay.getElement().src = getShipColor(port)
    }
    function removeShipOverlay(position){
        let MMSI = position.UserID;
        shipPositions.delete(MMSI)
        let overlay = shipOverlays.get(MMSI)
        shipOverlays.delete(MMSI)
        return overlay
    }

    function startAisSubscription(){
        let ws = aisWebSocket();
        setShipSocket(ws);
    }

    function stopAisSubscription(){
        shipSocket.close();
        setShipSocket(undefined);
        for (let overlay of shipOverlays.values()){
            map.removeOverlay(overlay)
        }
        shipOverlays.clear();
        shipPositions.clear();
    }

    function getShipPosition(mmsi){
        return shipPositions.get(mmsi)
    }


    //Handles the ais stream subscription
    useEffect(() => {
        if (shipSocket){
            shipSocket.onopen = event => {
                let checked_files = files.filter(f => checked[f.fileid]);
                let region = checked_files.find(isRegion)
                let bbox = [1000, 1000, -1000, -1000];
                for (let [latitude, longitude] of region.metadata.track){
                    if (bbox[0] > longitude) bbox[0] = longitude;
                    if (bbox[1] > latitude) bbox[1] = latitude;
                    if (bbox[2] < longitude) bbox[2] = longitude;
                    if (bbox[3] < latitude) bbox[3] = latitude;
                }
                shipSocket.send(JSON.stringify({bbox}))
            }
            shipSocket.onmessage = event => {
                let update = JSON.parse(event.data);
                if (update.all){
                    console.log("received ships:", update.all.length)
                    let overlays = update.all.map(createShipOverlay)
                    for (let overlay of overlays){
                        map.addOverlay(overlay)
                    }
                }
                if (update.add){
                    console.log("add new ship")
                    let overlay = createShipOverlay(update.add)
                    map.addOverlay(overlay)
                }
                if (update.rem){
                    console.log("rem ship")
                    let overlay = removeShipOverlay(update.rem)
                    map.removeOverlay(overlay)
                }
                if (update.mod){
                    console.log("move ship")
                    modifyShipOverlay(update.mod);
                }
            }
        }
        return () => {
            if (shipSocket){
                stopAisSubscription()
            }
        }
    }, [shipSocket])

    function createOverlayPopup(contentElement, lon, lat, offset) {
        let element = document.createElement("div");
        element.style.zIndex = 10
        element.className = "card";
        element.style.display = "block";

        let closeButton = document.createElement("button");
        closeButton.className="btn-close";
        closeButton.ariaLabel="Close";
        closeButton.style.float = "right";
        closeButton.style.margin = "16px";
        element.appendChild(closeButton);

        let content = document.createElement("div");
        content.className = "card-body";
        element.appendChild(content)
        content.appendChild(contentElement)


        let overlay = new Overlay({
            element,
            className: "ol-overlay-container ol-selectable on-top-overlay"
        })
        let position = fromLonLat([lon, lat])
        if (offset){
            position[0] += offset[0]
            position[1] += offset[1]
        }
        overlay.setPosition(position)
        closeButton.addEventListener("click", () => {overlay.setPosition(undefined)});
        return overlay
    }

    function print_ms(ms){
        let days = Math.floor(ms / 1000 / 60 / 60 / 24);
        let hours = Math.floor(ms / 1000 / 60 / 60) % 24;
        let minutes = Math.floor(ms / 1000 / 60) % 60;
        return `${days}days ${hours}hours ${minutes}minutes`;
    }

    // Fake
    function get_entry_time(mmsi, from_date, to_date){
        let interval = Math.floor((to_date.getTime() - from_date.getTime()) / (1000 * 3600 * 24))
        let entry_time = new Date(to_date);
        let rand = sfc32(...cyrb128(`${mmsi}`));
        entry_time.setDate(entry_time.getDate() - Math.floor(rand()*(interval-1) + 1));
        entry_time.setHours(rand()*24);
        entry_time.setMinutes(rand()*60);
        return entry_time;
    }
    // Fake
    function get_exit_time(mmsi, from_date, to_date){
        let interval = Math.floor((to_date.getTime() - from_date.getTime()) / (1000 * 3600 * 24))
        let exit_time = new Date(to_date);
        let rand = sfc32(...cyrb128(`${mmsi}`));
        exit_time.setHours(rand()*24);
        exit_time.setMinutes(rand()*60);
        return exit_time;
    }
    function createPortAnaliticsDiv(mmsi, boat_name, port){
        let div = document.createElement("div");
        let title = document.createElement("h5");
        title.textContent = `Port analytics for ${boat_name}`;
        div.appendChild(title);

        let entry_time = get_entry_time(mmsi, new Date(getTodayPlus(-3)), new Date());

        let fields = port ? [
            ["Port", port.name],
            ["Entry time", entry_time.toLocaleString()],
            ["Time spent in port", print_ms(new Date() - entry_time)]
        ] : [
            ["Port", "Ship is currently in open waters"]
        ]
        for (let [k, v] of fields){
            let row = document.createElement("p");
            row.textContent = `${k}: ${v}`;
            div.appendChild(row);
        }
        return div;
    }
    function createShipDetailsOverlay(details){
        let div = document.createElement("div");
        let title = document.createElement("h5");
        div.appendChild(title);
        title.textContent = details.boatName;
        for (let field of ["boatName", "callSign", "lengthMeters", "heightMeters", "widthMeters", "destinationName", "vesselType"]){
            let row = document.createElement("p");
            row.textContent = `${field}: ${details[field]}`
            div.appendChild(row);
        }

        let port_analitics_div = createPortAnaliticsDiv(details.mmsi, details.boatName, details.port);
        div.appendChild(port_analitics_div);

        return createOverlayPopup(div, details.Longitude, details.Latitude)
    }

    useEffect(() => {
        let overlay;
        if (showDetailsForShip){
            overlay = createShipDetailsOverlay(showDetailsForShip)
            map.addOverlay(overlay)
        }
        return () => {
            if (overlay)
                map.removeOverlay(overlay)
        }
    }, [showDetailsForShip])

    function getShipsInPort(port){
        let lat = port["Latitude"]
        let lon = port["Longitude"]
        let boundary = port["boundary"]
        let rad = 5000;
        if (port["Harbor Size"] === "Large") { rad = 10000; }
        if (port["Harbor Size"] === "Medium") { rad = 8000; }
        if (port["Harbor Size"] === "Small") { rad = 6000; }
        if (port["Harbor Size"] === "Very Small") { rad = 4000; }
        let inPort = []
        for (let [mmsi, position] of shipPositions){
            let isIn = false;
            if (boundary){
                let polygon = [...port.boundary]
                polygon.pop()
                if(isPointInPolygon({ lon: position.Longitude, lat: position.Latitude }, polygon)){
                    isIn = true
                }
            }else{
                let dist = getDistance({ lon: position.Longitude, lat: position.Latitude }, { lon, lat})
                isIn = dist < rad
            }
            if (isIn){
                inPort.push(mmsi);
            }
        }
        return inPort;
    }

    function createPortDetailsOverlay(port, report){
        let div = document.createElement("div");
        let title = document.createElement("h5");
        div.appendChild(title);
        title.textContent = `Port analytics for ${port["Main Port Name"]}`;
        let shipCount = document.createElement("div");
        shipCount.textContent = `Ships in port: ${report.length}`;
        div.appendChild(shipCount);

        let create_table_entry = (type, text) => {
            let t = document.createElement(type);
            // t.style.border = "1px solid black";
            // t.style.padding = "5px"
            t.textContent = text;
            return t;
        }
        //Scrollable div around table
        let table_scrollable_div = document.createElement("div");
        table_scrollable_div.className = "overflow-auto"
        table_scrollable_div.style.maxHeight = "500px"
        //Ship table
        let table = document.createElement("table");
        table_scrollable_div.appendChild(table);
        table.className = "table table-striped table-bordered"
        table.style.maxHeight = "500px"
        // table.style.borderCollapse = true;
        let thead = document.createElement("thead");
        table.appendChild(thead);
        let tbody = document.createElement("tbody");
        table.appendChild(tbody);
        let row = document.createElement("tr");
        row.appendChild(create_table_entry("th", "MMSI"));
        row.appendChild(create_table_entry("th", "Entry time"));
        row.appendChild(create_table_entry("th", "Exit time"));
        row.appendChild(create_table_entry("th", "Time in port"));
        thead.appendChild(row);
        for (let {mmsi, entry_time, exit_time, time_spent} of report){
            let row = document.createElement("tr");
            row.appendChild(create_table_entry("td", mmsi));
            row.appendChild(create_table_entry("td", entry_time.toLocaleString()));
            row.appendChild(create_table_entry("td", exit_time.toLocaleString()));
            row.appendChild(create_table_entry("td", time_spent));
            tbody.appendChild(row);
        }
        div.appendChild(table_scrollable_div);

        return createOverlayPopup(div, port.Longitude, port.Latitude)
    }

    let fromDate = useRef()
    let toDate = useRef()
    let produceReport = useRef()
    useEffect(() => {
        let overlay;
        if (portDetails){
            let port = ports.find(p => p["Main Port Name"] == portDetails);
            setPortDetailedInfo(port);
        }
        if (portDetails && displayPortDetails){
            let port = ports.find(p => p["Main Port Name"] == portDetails);
            console.log(port)
            let shipsInPort = getShipsInPort(port);
            console.log(shipsInPort);
            let report = [];
            for (let mmsi of shipsInPort){
                let from_time = new Date(fromDate.current.value)
                let to_time = new Date(toDate.current.value)
                let entry_time = get_entry_time(mmsi, from_time, to_time)
                let exit_time = get_exit_time(mmsi, from_time, to_time)
                let time_spent = print_ms(exit_time - entry_time);
                report.push({mmsi, entry_time, exit_time, time_spent});
            }
            if (produceReport.current.checked){
                produceShipReport(token.token, trial_id, port, report).then((data) => {
                    if (data.err) return handleError(data.err)
                    reload(()=>{});
                })
            }
            overlay = createPortDetailsOverlay(port, report)
            map.addOverlay(overlay)
        }
        return () => {
            setPortDetailedInfo(undefined);
            if (overlay)
                map.removeOverlay(overlay)
        }
    }, [ports, portDetails, displayPortDetails])

    // handle showing spot beams
    useEffect(() => {

        let getSpotBeamFeature = (center) => {
            let radius = spotBeamRad;
            let geometry = circular([center.lon, center.lat], radius).transform("EPSG:4326", "EPSG:3857")

            let feature = new Feature({
                geometry 
            })
            feature.setStyle(
                new Style({
                    stroke: new Stroke({
                        width: 4,
                        color: "blue"
                    }),
                    fill: new Fill({
                        color: "rgba(0, 0, 255, 0.1)"
                    })
                })
            )
            return feature;
        }
        if (showSpotBeams && numSpotBeams){
            let buildSpotBeams = () => {
                let randAns = spotBeams.getRandom(Array.from(shipPositions.values()), numSpotBeams, spotBeamRad)
                let {count, centers} = spotBeams.getReasonable(Array.from(shipPositions.values()), numSpotBeams, spotBeamRad)
                let displayPercent = (num) => {
                    return `${(num / shipPositions.size * 100).toFixed(2)}% (${num} / ${shipPositions.size})`
                }
                //TODO: Have something better than strings
                setShipsCoveredMessage(
                    [
                        `Random:            ${displayPercent(randAns.count)}`,
                        `Leader Clustering: ${displayPercent(count)}`
                    ]
                )
                if (spotBeamsLayer){
                    let spotBeamFeatures = centers.map(getSpotBeamFeature)
                    spotBeamsLayer.getSource().clear();
                    spotBeamsLayer.getSource().addFeatures(spotBeamFeatures);    
                }
            }
            buildSpotBeams()
            let intrevalId = setInterval(buildSpotBeams, 10*1000)
            return () => {
                clearInterval(intrevalId)
            }
        }
        if (!showSpotBeams && spotBeamsLayer){
            spotBeamsLayer.getSource().clear()
        }
    }, [showSpotBeams, numSpotBeams, spotBeamRad])

    function beep() {
        let snd = new Audio("data:audio/wav;base64,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");  
        snd.play();
    }

    let defsnd = new Audio("data:audio/wav;base64,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");
    let danger =
        trial.name == "AsanaCat-CatSla" ?
        new Audio("/audio/danger.wav") :
        defsnd;
    let buffer = 
        trial.name == "AsanaCat-CatSla" ?
        new Audio("/audio/buffer.wav") :
        defsnd;
    function getTrackedFeature(){
        let feature = new Feature({
            geometry: new Point(fromLonLat([trackedLatLon.lon, trackedLatLon.lat]), 20)
        })
        let src = circle_black;
        if (trackedLatLon.in_danger){
            src = circle_red;
            danger.play()
        }
        else if (trackedLatLon.in_buffer){ 
            src = circle_yellow; 
            buffer.play();
        }
        feature.setStyle(
            new Style({
                image: new Icon({
                    src
                })
            })
        )
        return feature;
    }

    useEffect(()=>{
        if (!trackedLayer || !trackedLatLon) return;
        let feature = getTrackedFeature();
        //console.log("new loc", feature.getGeometry().getCenter())
        let updateExtent = false;
        if (trackedLayer.getSource().getFeatures().length === 0){
            updateExtent = true;
        }
        trackedLayer.getSource().clear() 
        trackedLayer.getSource().addFeature(feature)
        if (updateExtent){
            let extent = createEmpty();
            extend(extent, trackedLayer.getSource().getExtent());
            extend(extent, gpxLayer.getSource().getExtent());
            if (!isEmpty(extent))
                map.getView().fit(extent, {
                    padding: [10, 10, 10, 10]
                })
        }
    }, [trackedLatLon])

    function isGpx(f){
        return (f.sensor === "Output GPX" || fileExt(f.filename) === "gpx") && f.metadata?.track
    }
    function isRegion(f){
        // TODO: We should instead set a type equal to region. However this would not be backwards compatible.
        return isGpx(f) && f.filename.includes("-region-") && (f.metadata?.desc === "Other" || f.metadata?.desc === "Region")
    }
    function numSelectedRegions(){
        return files
            .filter(f => checked[f.fileid])
            .filter(isRegion)
            .length
    }

    function haveGpx(){
        return files
            .filter(f => checked[f.fileid])
            .filter(f => (f.sensor === "Output GPX" || fileExt(f.filename) === "gpx") && f.metadata?.track)
            .length > 0
    }

    function haveBoxCompare(){
        let numGpx = files
            .filter(f => checked[f.fileid])
            .filter(f => (f.sensor === "Output GPX" || fileExt(f.filename) === "gpx") && f.metadata?.track)
            .length

        return numGpx === 2 && haveBox
    }

    function haveImg(){
        return files
            .filter(f => checked[f.fileid])
            .filter(f => isImage(f.filename) && f.metadata?.lat)
            .filter(f => !SATTELITE_SENSORS.includes(f.sensor))
            .length > 0
    }

    function haveAir(){
        return airstations.length > 0
    }

    function genGpxFeatures(){
        let colorForUser = (user) => {
            return common_colors[hashCode(user)%20];
        }
        let good_color = '#AAFF00', bad_color = "#FF160C";

        let checked_files = files.filter(f => checked[f.fileid]);

        let multiUser = ()=>{
            let files = checked_files.filter(f => (f.sensor === "Output GPX" || fileExt(f.filename) === "gpx") && f.metadata?.track);
            for (let i=1; i<files.length; ++i){
                if (files[i].user != files[0].user) return true;
            }
            return false;
        }
        return checked_files.filter(f => (f.sensor === "Output GPX" || fileExt(f.filename) === "gpx") && f.metadata?.track).map(f => {
            let color = colorForUser(multiUser() ? f.user : f.filename);
            if (f.metadata.desc === "Safe") {color = "green"}
            if (f.metadata.desc === "Buffer") {color = "yellow"}
            if (f.metadata.desc === "Danger") {color = "red"}
            if (f.metadata.desc === "Other") {color = "blue"}
            if (!f.metadata.track[0][2]){
                let feature = new Feature({
                    geometry: new LineString(f.metadata.track.map(latlon => {
                        let lat = latlon[0]
                        let lon = latlon[1]
                        return fromLonLat([lon, lat])
                    })), 
                    name: f.filename
                })
                feature.setStyle(
                    new Style({
                        stroke: new Stroke({
                            color,
                            width: 5
                        })
                    })
                )
                return feature;
            }else{
                let lines = [];
                for (let i=0; i<f.metadata.track.length-1; ++i){
                    let c = f.metadata.track[i], n = f.metadata.track[i+1];
                    let line = new Feature({
                        geometry: new LineString([fromLonLat([c[1], c[0]]), fromLonLat([n[1], n[0]])])
                    })
                    line.setStyle(
                        new Style({
                            stroke: new Stroke({
                                color: c[2] === "good" ? good_color : c[2]==="bad" ? bad_color : colorOnPoll({aqi: c[2]}, 1),
                                width: 5
                            })
                        })
                    )
                    lines.push(line);
                }
                return lines;
            }
        }).flat(1)
    }
    function getCopernicus(){
        let checked_files = files.filter(f => checked[f.fileid]);
        return checked_files.filter(f => (SATTELITE_SENSORS.includes(f.sensor) || fileExt(f.filename) === "jpg") && f.metadata?.bbox).map(f => {
            let url = `/copernicus_images/${f.filename}`;
            let bbox = f.metadata.bbox;
            let extent = boundingExtent([fromLonLat([bbox[0], bbox[1]]), fromLonLat([bbox[2], bbox[3]])]);
            console.log(url, extent);
            return new Static({
                url: url,
                imageExtent: extent
            })    
        })
    }
    function getGeotiff(){
        let checked_files = files.filter(f => checked[f.fileid]);
        return checked_files.filter(f => fileExt(f.filename) === "tif").map(f => {
            let url = `/geotiff/${f.filename}`;
            let source = new GeoTIFF({
                convertToRGB: 'auto',
                sources: [
                    {url}
                ]
            });
            return new WebGLTileLayer({
                source             
            })    
        })
    }

    //todo: fix this
    useEffect(() => {
        if (gpxLayer){
            let features = genGpxFeatures();
            gpxLayer.getSource().set("features", features);
        }
    }, [checked])

    useEffect(()=>{
        if (osm) osm.setVisible(base === "osm");
        if (sat) sat.setVisible(base === "sat");
    }, [base])

    useEffect(()=>{
        if (gpxLayer) gpxLayer.setVisible(gpxVisible)
    }, [gpxVisible])
    
    useEffect(()=>{
        if (imagesLayer) imagesLayer.setVisible(imagesVisible)
        if (overlays){
            overlays.map(o => {
                o.setPosition(imagesVisible ? o.asdf : undefined); 
            })
        }
    }, [imagesVisible])
    
    useEffect(()=>{
        if (airLayer) airLayer.setVisible(airLayerVisible)
    }, [airLayerVisible])

    useEffect(()=>{
        if (airLayer && airTime){
            let airpoll = airstations.find(f => f.filename.includes(airTime));
            airLayer.getSource().clear();
            airLayer.getSource().addFeatures(getAirFeatures(airpoll));
            if (firstAir){
                let extent = createEmpty();
                extend(extent, airLayer.getSource().getExtent());
                if (!isEmpty(extent))map.getView().fit(extent, {
                    padding: [-700, -500, -1200, 0]
                })
                setFirstAir(false);
            }
        }
    }, [airTime, base, airstations])

    useEffect(()=>{
        if (visLayer){
            let visFeatures = [].concat.apply([], visualizations.map(getVisFeatures));
            visLayer.getSource().clear();
            visLayer.getSource().addFeatures(visFeatures);    
            let extent = createEmpty();
            extend(extent, visLayer.getSource().getExtent());
            if (!isEmpty(extent))
                map.getView().fit(extent, {
                    padding: [100, 100, 100, 100]
                })
        }
    }, [visualizations])

    async function getAndShowPorts(){
        if (ports.length === 0){
            let data = await getShipPorts(token.token)
            if (data.err) return handleError(data.err, setToken);
            setPorts(data.ports)
        }
        setShowPorts("all")
    }
    useEffect(()=>{
        function getPortFeature(port){
            let radius = 5000, color = "grey";
            if (port["Harbor Size"] === "Large"){ radius = 10000; color = "purple"}
            if (port["Harbor Size"] === "Medium"){ radius = 8000; color = "blue"}
            if (port["Harbor Size"] === "Small"){ radius = 6000; color = "yellow"}
            if (port["Harbor Size"] === "Very Small"){ radius = 4000; color = "orange"}
            let geometry = port.boundary ?
                new Polygon([port.boundary.map(({ lon, lat }) => fromLonLat([lon, lat]))]) :
                circular([port["Longitude"], port["Latitude"]], radius).transform("EPSG:4326", "EPSG:3857")

            let feature = new Feature({
                geometry,
                name: `Port:${port["Main Port Name"]}`
            })
            feature.setStyle(
                new Style({
                    stroke: new Stroke({
                        width: 4,
                        color: color
                    }),
                    // TODO: Add a feature to toggle the text
                    text: new Text({
                        text: port["Main Port Name"],
                        font: "12px sans-serif",
                        fill: new Fill({color}),
                        overflow: false
                    })
                })
            )
            return feature;
        }
        let portsToShow = ports;
        if (showPorts === "none") portsToShow = []
        if (showPorts === "detailed") portsToShow = portsToShow.filter(port => port.boundary)
        if (portsLayer){
            let portsFeatures = portsToShow.map(getPortFeature)
            portsLayer.getSource().clear();
            portsLayer.getSource().addFeatures(portsFeatures);    
        }
        segmentedPorts.clear();
        for (let port of portsToShow){
            addSegmentedPort(port)
        }
        //Update existiing ships
        for (let [mmsi, position] of shipPositions){
            let overlay = shipOverlays.get(mmsi)
            let port = getShipPort(position)
            overlay.getElement().src = getShipColor(port)
        }

        return () => {
            segmentedPorts.clear()
        }
    }, [ports, showPorts])

    const [orphanedWells, setOrphanedWells] = useState([])
    const [wellDetails, setWellDetails] = useState(undefined)
    async function getOrphanedWells(){
        let data = await fetch(`/api/getorphanwells/${token.token}`)
            .then(data => data.json())
        setOrphanedWells(data.wells)
    }
    async function getOrphanedWellsInRegion(){
        let checked_files = files.filter(f => checked[f.fileid]);
        let regions = checked_files.filter(isRegion)
        let bboxes = regions.map(region => {
            let bbox = [1000, 1000, -1000, -1000];
            for (let [latitude, longitude] of region.metadata.track){
                if (bbox[0] > longitude) bbox[0] = longitude;
                if (bbox[1] > latitude) bbox[1] = latitude;
                if (bbox[2] < longitude) bbox[2] = longitude;
                if (bbox[3] < latitude) bbox[3] = latitude;
            }
            return bbox
        })
        let data = await fetch(`/api/getorphanwellsinregion`, {
            method: "POST",
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({token: token.token, bboxes})
        })
            .then(data => data.json())
        if (data.wells.length === 0){alert("No orphaned wells in this region")}
        setOrphanedWells(data.wells)
    }
    useEffect(() => {
        let getWellFeature = ([id, lat, lon]) => {
            let geometry = new Circle(fromLonLat([lon, lat]), 20)

            let feature = new Feature({
                geometry,
                name: `Well:${id}`
            })
            feature.setStyle(
                new Style({
                    stroke: new Stroke({
                        width: 5,
                        color: "red"
                    }),
                    fill: new Fill({
                        color: "rgba(255, 0, 0, 0.1)"
                    })
                })
            )
            return feature;
        }

        if (wellsLayer){
            let features = orphanedWells.map(getWellFeature)
            wellsLayer.getSource().addFeatures(features)
            wellsLayer.setVisible(orphanedWells.length > 0)
        }
        return () => {
            if (wellsLayer){
                wellsLayer.getSource().clear()
                wellsLayer.setVisible(false)
            }
        }
    }, [orphanedWells])
    useEffect(() => {
        let createWellDetailsOverlay = (well) => {
            let div = document.createElement("div");
            let title = document.createElement("h5");
            div.appendChild(title);
            title.textContent = `Details for ${well["Well name"]}`;
            for (let field of ["Well name", "Well identifier", "Type", "Status", "State", "County"]){
                let row = document.createElement("p");
                row.textContent = `${field}: ${well[field]}`
                div.appendChild(row);
            }
            return createOverlayPopup(div, well.Longitude, well.Latitude, [14, -14])
        }

        let overlay;
        if (wellDetails){
            overlay = createWellDetailsOverlay(wellDetails)
            map.addOverlay(overlay)
        }
        return () => {
            if (overlay)
                map.removeOverlay(overlay)
        }
    }, [wellDetails])

    function calcBoxDist(){
        let tracks = files
            .filter(f => checked[f.fileid])
            .filter(f => (f.sensor === "Output GPX" || fileExt(f.filename) === "gpx") && f.metadata?.track);
        let extent = boxLayer.getSource().getExtent();
        let isin = latlon => {
            let lat = latlon[0]
            let lon = latlon[1]
            return containsCoordinate(extent, fromLonLat([lon, lat]))
        }
        let track1 = tracks[0].metadata.track.filter(isin)
        let track2 = tracks[1].metadata.track.filter(isin)
        getDist(track1, track2)
            .then(data => {
                let text = 
`
Minimal distance: ${data.min.toFixed(2)}m
Average distance: ${data.avg.toFixed(2)}m
Maximal distance: ${data.max.toFixed(2)}m
`;
                boxLayer.getSource().getFeatures()[0].setStyle(
                    new Style({
                        stroke: new Stroke({
                            width: 0.5,
                            color: [50, 50, 255, 1]
                        }),
                        fill: new Fill({
                            color: [255, 255, 255, 0.3]
                        }),
                        text: new Text({
                            font:"20px sans-serif",
                            text,
                            overflow:true
                        })
                    })
                )
            })
    }

    function showGeofencePopup(){setIsGeofencePopupVisible(true)}

    function hideGeofencePopup(){setIsGeofencePopupVisible(false)}

    function showRegionPopup(){setIsRegionPopupVisible(true)}

    function hideRegionPopup(){setIsRegionPopupVisible(false)}

    const geoName = useRef();
    const geoType = useRef()
    const geoBufSize = useRef();
    function submitGeofence(e){
        e.preventDefault();
        let name = `geofence-${geoName.current.value}`;
        let type = geoType.current.value;
        let bufSize = type === "Danger" ? geoBufSize?.current?.value : null;
        let coordinates = drawnLayer.getSource().getFeatures()[0].getGeometry().getCoordinates()[0];
        coordinates = coordinates.map((coord) => {
            return toLonLat(coord);
        })
        uploadPoly(token.token, trial_id, name, type, bufSize, coordinates, setToken, (file) => {
            reload(()=>{
                //todo: fix this
                /*
                let c = Object.assign({}, checked); 
                c[file.fileid]=true; 
                setChecked(c)
                */
            })
            hideGeofencePopup()
            setIsDrawing(false);
            draw.setActive(false);
            modify.setActive(false);
            snap.setActive(false);
            drawnLayer.getSource().clear()
            setHasDrawn(false);
            window.alert("Geofence saved. You can view it in map/table/tree view.")
        });
        return false;
    }

    const regName = useRef();
    function submitRegion(e){
        e.preventDefault();
        //let extent = boxLayer.getSource().getExtent();
        let region_name = regName.current.value.replace(/["']/g, "_")
        let name=`region-${region_name}`;
        let type="Other";
        let bufSize=null;
        let coordinates = boxLayer.getSource().getFeatures()[0].getGeometry().getCoordinates()[0];
        coordinates = coordinates.map((coord) => {
            return toLonLat(coord);
        })
        uploadPoly(token.token, trial_id, name, type, bufSize, coordinates, setToken, (file) => {
            reload(()=>{});
            hideRegionPopup();
            boxLayer.getSource().clear();
            setHaveBox(false);
            window.alert("Region saved. You can view it in map/table/tree view.")
        })
        return false;
    }

    const place = useRef();
    const searchForm = useRef();
    async function findPlace(e){
        e.preventDefault();
        let result = await queryNominatim(place.current.value);
        if (!result[0]?.boundingbox){
            alert("Place not found. Try searching for a city or address?");
            return false;
        }
        let bbox = result[0]?.boundingbox;
        console.log(bbox);
        let extent = boundingExtent([fromLonLat([bbox[2], bbox[0]]), fromLonLat([bbox[3], bbox[1]])]);
        map.getView().fit(extent, {padding: [10, 10, 10, 10]});
        return false;
    }


    const numSpotBeamsRef = useRef()
    const spotBeamRadRef = useRef()
    function submitShowSpotBeams(){
        setShowSpotBeams(true)
        setNumSpotBeams(numSpotBeamsRef.current.value)
        setSpotBeamRad(spotBeamRadRef.current.value * 1000)
    }
    function hideSpotBeams(){
        setShowSpotBeams(false)
        setNumSpotBeams(undefined)
        setSpotBeamRad(undefined)
        setShipsCoveredMessage([])
    }

    function getControls(){
        return [
            (
            <div style={{position: "absolute", top: "10px", left: "50px"}}>
                <div style={{float: "left"}}>
                    <Form onSubmit={findPlace} ref={searchForm}>
                        <Row>
                            <Col xs="auto" style={{padding:"0px"}}>
                                <Form.Control ref={place} type="text" placeholder='Enter city or address'/>
                            </Col>
                            <Col xs="auto" style={{padding:"0px"}}>
                                <Button variant="light" type="submit"><img style={{height:"1em"}} src={searchIcon}/></Button>
                                <Button variant="light" style={{backgroundColor:"white"}} onClick={() => searchForm.current.reset()}>X</Button>
                            </Col>
                        </Row>
                    </Form>
                </div>
            </div>
            ),
            (
            <div style={{position: "absolute", top: "40px", right: "10px"}}>
                <div>
                    <Button style={{marginBottom: "10px", float:"right"}} onClick={()=>{
                        setBase(base==="osm" ? "sat" : "osm");
                    }}>Switch to {base==="osm" ? "satellite" : "map"}</Button>
                </div>
                {
                    haveBox ?
                    <div style={{display:"block", marginBottom:"10px", textAlign:"right"}}><Button onClick={showRegionPopup}>Save region</Button></div> :
                    <div style={{display:"block", marginBottom:"10px", textAlign:"right"}}><Button onClick={()=>alert("To select a region, hold Ctrl (Windows) or Command ⌘ (Mac OS) and drag over the map")}>Select region</Button></div>
                }
                {
                    isDrawing ?
                    null :
                    <div style={{display:"block", marginBottom:"10px", textAlign:"right"}}>
                    <Button onClick={() => {
                        setIsDrawing(true);
                        draw.setActive(true);
                        modify.setActive(true);
                        snap.setActive(true);
                    }}>
                        Create geofence
                    </Button>
                    </div>
                }
                {
                    hasDrawn ?
                    <div style={{display:"block", marginBottom:"10px", textAlign:"right"}}>
                    <Button onClick={showGeofencePopup}>
                        Save geofence
                    </Button>
                    </div> :
                    null
                }
                {
                    haveTracker() ?
                    (
                        <div style={{display:"block", marginBottom:"10px", textAlign:"right"}}>
                            {trackedSocket ?
                            <Button onClick={()=>{
                                trackedSocket.close()
                                setTrackedSocket(undefined)
                            }}>
                                Stop tracking
                            </Button> :
                            <Button onClick={startTracking}>
                                Start tracking
                            </Button>
                            }
                        </div>
                    ) :
                    null
                }
                {
                    //TODO: Have a better way to enable ship tracking for various trials
                    numSelectedRegions() === 1 && 
                    [
                        "trial", 
                        "Inmarsat-ship-tracking-Copernicus-data-demo-v1",
                        "Inmarsat-ship-traffic-satellites-spot-beams-demo1",
                        "Inmarsat-ship-tracking-ports-in-and-out-demo2",
                        "Ship-tracking-ports-in-and-out-demo",
                        "BV Test",
                        "Trial 1",
                        "Test #1",
                        "BLM Test",
                        "TRIDENT AIS",
                        "spot-beam-tests",
                        "aero",
                        "Ship-tracking",
                        "Ship-tracking-new",
                        "CASSINI-Hackathon-Marine-Trust"
                    ].includes(trial.name) ?
                    <div style={{display:"block", marginBottom:"10px", textAlign:"right"}}>
                        {
                            shipSocket ?
                            <Button onClick={stopAisSubscription}>
                                Stop tracking ships
                            </Button> :
                            <Button onClick={startAisSubscription}>
                                Start tracking ships in region
                            </Button>
                        }
                    </div> : 
                    null
                }
                {
                    //TODO: Abstract out these type of analisis as a separate constructs
                    shipSocket && 
                    [
                        "trial", "aero",
                        "Inmarsat-ship-tracking-Copernicus-data-demo-v1",
                        "Inmarsat-ship-traffic-satellites-spot-beams-demo1",
                        "Inmarsat-ship-tracking-ports-in-and-out-demo2",
                        "Ship-tracking-ports-in-and-out-demo",
                        "spot-beam-tests",
                        "Ship-tracking",
                        "Ship-tracking-new",
                    ].includes(trial.name) ?
                    <div style={{display:"block", marginBottom:"10px", textAlign:"right"}}>
                        {
                            showSpotBeams ?
                            <Button onClick={hideSpotBeams}>
                                Stop constructing spot beams
                            </Button> :
                            <Button onClick={() => {setShowSpotBeams(true)}}>
                                Start constructing spot beams
                            </Button>
                        }
                    </div> : 
                    null
                }
                {
                    trial.sensors.includes("Ship Ports") ?
                    <div style={{display:"block", marginBottom:"10px", textAlign:"right"}}>
                        {
                            showPorts === "none" ?
                                <Button onClick={getAndShowPorts}>
                                    Show all ship ports
                                </Button> :
                                showPorts === "all" ?
                                    <Button onClick={() => { setShowPorts("detailed") }}>
                                        Show only detailed ship ports
                                    </Button> :
                                    <Button onClick={() => { setShowPorts("none") }}>
                                        Hide ship ports
                                    </Button>
                        }
                    </div> :
                    null
                }
                {
                    trial.sensors.includes("Orphaned Wells") ?
                    <div style={{display:"block", marginBottom:"10px", textAlign:"right"}}>
                        {
                            orphanedWells.length > 0 ?
                                <Button onClick={() => { setOrphanedWells([]) }}>
                                    Hide orphaned wells
                                </Button> :
                                numSelectedRegions() > 0 ?
                                <Button onClick={getOrphanedWellsInRegion}>
                                    Show orphaned wells in region
                                </Button> :
                                <Button onClick={getOrphanedWells}>
                                    Show orphaned wells
                                </Button>
                        }
                    </div> :
                    null
                }
                {
                    haveGpx() ?
                    <div>
                        <div style={{float:"right"}}>
                            <ToggleButton 
                                type="checkbox"
                                variant="outline-primary" 
                                checked={gpxVisible} 
                                onChange={event => {setGpxVisible(event.currentTarget.checked)}}
                            >
                                tracks (GPX)
                            </ToggleButton>
                        </div>
                    </div>:
                    null
                }{
                    haveImg() ?
                    <div>
                        <div style={{float:"right"}}>
                            <ToggleButton 
                                type="checkbox"
                                variant="outline-primary" 
                                checked={imagesVisible} 
                                onChange={event => {setImagesVisible(event.currentTarget.checked)}}
                            >
                                photos (photoSpot)
                            </ToggleButton>
                        </div>
                    </div>:
                    null
                }{
                    haveAir() ?
                    <div>
                        <div style={{float:"right"}}>
                            <ToggleButton 
                                type="checkbox"
                                variant="outline-primary" 
                                checked={airLayerVisible} 
                                onChange={event => {setAirLayerVisible(event.currentTarget.checked)}}
                            >
                                Air pollution
                            </ToggleButton>
                            <div>
                                {
                                    airstations.map((f, i) => {
                                        let time = getTime(f.filename);
                                        return(
                                            <Form.Check key={i} checked={airTime === time} style={{color: getReadableColor()}} name="group" type='radio' label={time} onChange={event => {
                                                if (event.currentTarget.checked){
                                                    setAirTime(time);
                                                }
                                            }}/>
                                        )
                                    })
                                }
                            </div>
                        </div>
                    </div>:
                    null
                }{
                    haveBoxCompare() ?
                    <div style={{float: "right"}}>
                        <Button variant="primary" onClick={calcBoxDist}>Compare GPX tracks in selected region</Button>
                    </div> :
                    null
                }
            </div>
            )
        ]
    }

    function getTodayPlus(n){
        let today = new Date()
        let result = new Date(today.setDate(today.getDate()+n))
        return result.toISOString().split("T")[0];
    }

    useEffect(() => {
        let checked_files = files.filter(f => checked[f.fileid]);
        let features = genGpxFeatures();
        let gpxLayer = new Vector({
            source: new VectorSource({
                features
            })
        })

        let staticLayers = 
        getCopernicus().map(source => new ImageLayer({
            source
        }));
        let geotiffs = getGeotiff()

        let images = checked_files.filter(f => isImage(f.filename) && f.metadata?.lat && !SATTELITE_SENSORS.includes(f.sensor)).map(f => {
            let feature = new Feature({
                geometry: new Point(fromLonLat([f.metadata.lon, f.metadata.lat]))
            });
            return feature;
        })
        let imagesLayer = new Vector({
            source: new VectorSource({
                features: images
            })
        })
        let overlays = checked_files.filter(f => isImage(f.filename) && f.metadata?.lat && !SATTELITE_SENSORS.includes(f.sensor)).map(f => {
            let element = document.createElement("a");
            let img = document.createElement("img");
            img.src = getThumbLink(f, "64x64");
            img.title = f.filename;
            element.appendChild(img);
            element.href = f.publink;
            element.target = "_blank"
            element.style = `
                position: absolute;
                padding: 0px;
                border-radius: 5px;
                border: 1px solid #cccccc;
                bottom: -32px;
                left: -32px;
            `;
            let overlay = new Overlay({
                element
            })
            overlay.setPosition(fromLonLat([f.metadata.lon, f.metadata.lat]))
            overlay.asdf = fromLonLat([f.metadata.lon, f.metadata.lat]);
            return overlay;
        })

        //Air pollution
        let isMounted = true;
        let airfiles = checked_files.filter(f=>f.sensor==="Air-pollution");
        getJSONs(token.token, airfiles)
            .then(data => {
                if (!isMounted){
                    console.log("recieved response after dismount"); 
                    return;
                }
                if (data.err) return;
                let newairs = airfiles.map((f, i) => {
                    let newf = Object.assign({}, f);
                    newf.metadata = data.objs[i]
                    return newf;
                })
                setAirstations(newairs);
                if (newairs.length>0) setAirTime(getTime(newairs[0].filename))
            })
        let airs = [];
        let airpoll = airstations[0];
        if (airpoll) {
            setAirTime(getTime(airpoll.filename))
            airs = getAirFeatures(airpoll);
        }
        let airLayer = new Vector({
            source: new VectorSource({
                features: airs
            })
        })

        let visfiles = checked_files.filter(f => f.sensor === "Map visualizations")
        getJSONs(token.token, visfiles)
            .then(data => {
                if (!isMounted){
                    console.log("recieved response after dismount"); 
                    return;
                }
                if (data.err) return;
                let vis = visfiles.map((f, i) => {
                    let newvis = Object.assign({}, f);
                    newvis.metadata = data.objs[i];
                    return newvis
                })
                setVisualizations(vis);
            })
        let visFeatures = [].concat.apply([], visualizations.map(getVisFeatures));
        let visLayer = new Vector({
            source: new VectorSource({
                features: visFeatures
            })
        })

        // Ship ports
        // let portfile = checked_files.filter(f => f.sensor === "Ship Ports")[0]
        // if (portfile){
        //     getCSV(token.token, portfile)
        //         .then(data => {
        //             if (!isMounted) {
        //                 console.log("recieved response after dismount");
        //                 return;
        //             }
        //             if (data.err) return;
        //             setPorts(data.rows)
        //         })
        // }
        let portsLayer = new Vector({
            source: new VectorSource({
                features: []
            })
        })
        let wellsLayer = new Vector({
            source: new VectorSource({
                features: [],
                attributions: ["USGS US Orphaned Wells dataset"]
            })
        })
        wellsLayer.setVisible(orphanedWells.length > 0)
        let spotBeamsLayer = new Vector({
            source: new VectorSource({
                features: []
            })
        })

        let osm = new TileLayer({source: new OSM()});
        let sattelite = new TileLayer({source: new XYZ({
            attributions: ['Powered by Esri',
                'Source: Esri, DigitalGlobe, GeoEye, Earthstar Geographics, CNES/Airbus DS, USDA, USGS, AeroGRID, IGN, and the GIS User Community'],
            attributionsCollapsible: false,
            url: 'https://services.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}',
            maxZoom: 17
        })});

        let trackedFeatures = []
        if (trackedLatLon){
            trackedFeatures.push(getTrackedFeature());
        }
        let trackedSource = new VectorSource({features:trackedFeatures});
        let trackedLayer = new Vector({source: trackedSource});

        let drawnSource = new VectorSource()
        let drawnLayer = new Vector({
            source: drawnSource
        });
        setDrawnLayer(drawnLayer);
        drawnSource.on('addfeature', (event) => {
            let features = event.target.getFeatures();
            if (features.length > 1){
                event.target.removeFeature(features[0]);
            }
        })
        drawnSource.on('change', (event) => {
            if (event.target.getFeatures().length > 0){
                if (!hasDrawn) setHasDrawn(true);
            }else{
                if (hasDrawn) setHasDrawn(false);
            }
        })

        let draw = new Draw({
            source: drawnSource,
            type: "Polygon"
        });
        setDraw(draw);
        let modify = new Modify({source: drawnSource});
        setModify(modify);
        let snap = new Snap({source: drawnSource});
        setSnap(snap);
        draw.setActive(false);
        modify.setActive(false);
        snap.setActive(false);

        let dragBox = new DragBox({
            condition: platformModifierKeyOnly
        })

        let boxLayer = new Vector({
            source: new VectorSource()
        });
        setBoxLayer(boxLayer);
        dragBox.on('boxstart', (e) => {
            boxLayer.getSource().clear()
            setHaveBox(false);
        })
        dragBox.on('boxend', (e) => {
            // Get the current dragbox coordinateds 
            let coordinates = dragBox.getGeometry().getCoordinates();
            // Create the polygon and pass the coordinates
            let polygonFeature = new Feature(
                                new Polygon(coordinates));
            polygonFeature.setStyle(
                new Style({
                    stroke: new Stroke({
                        width: 0.5,
                        color: [50, 50, 255, 1]
                    }),
                    fill: new Fill({
                        color: [255, 255, 255, 0.3]
                    })
                })
            )
            boxLayer.getSource().addFeature(polygonFeature);
            setHaveBox(true)
        })
        window.onkeydown = (e)=>{
            if (e.key==="Escape"){
                boxLayer.getSource().clear()
                drawnSource.clear()
                setHasDrawn(false);
                setHaveBox(false);
                setShowDetailsForShip(undefined)
                setWellDetails(undefined)
                setPortDetails(undefined)
                setDisplayPortDetails(false)
            }
        }

        osm.setVisible(base === "osm");
        sattelite.setVisible(base === "sat");

        let map = new OlMap({
            controls: defaultControls().extend([
                new ScaleLine({}),
                new FullScreen({})
            ]),
            layers: [
                osm,
                sattelite]
                .concat(staticLayers)
                .concat(geotiffs)
                .concat([
                    portsLayer,
                    wellsLayer,
                    gpxLayer,
                    imagesLayer,
                    airLayer,
                    boxLayer,
                    drawnLayer,
                    visLayer,
                    trackedLayer,
                    spotBeamsLayer
                ]),
            overlays,
            view: trial.lastmap ? 
                    new View({
                        projection: view_projection,
                        center: trial.lastmap.center,
                        zoom: trial.lastmap.zoom
                    }) :
                    new View({
                        projection: view_projection,
                        center: [0, 0],
                        zoom: 4
                    }),
            target: mapElement.current,
            interactions: defaultInteractions().extend([dragBox, draw, modify, snap])
        });

 
        let extent = createEmpty();
        extend(extent, gpxLayer.getSource().getExtent());
        extend(extent, imagesLayer.getSource().getExtent());
        extend(extent, airLayer.getSource().getExtent());
        for (let staticLayer of staticLayers){
            extend(extent, staticLayer.getSource().getImageExtent());
        }

        let padding = isEmpty(airLayer.getSource().getExtent()) ? [100, 100, 100, 100] : [-700, -500, -1200, 0]
        if (!isEmpty(extent))map.getView().fit(extent, {
            padding
        })

        if (geotiffs.length > 0){
            Promise.all(geotiffs.map(async geotiff => {
                let view = await geotiff.getSource().getView()
                let extent = transformExtent(view.extent, view.projection, view_projection)
                return extent
            })).then(extents => {
                for (let current of extents){
                    extend(extent, current)
                }
                map.getView().fit(extent, {padding})
            })
        }

        let intervalId = setInterval(async () => {
            let view = map.getView();
            await updateLastMap(token.token, trial_id, {center: view.getCenter(), zoom: view.getZoom()});
            return
        }, 5000)

        map.on("click", async (e) => {
            const clickable = map.forEachFeatureAtPixel(e.pixel, function (feature) {
                let name = feature.get("name")
                if (name.startsWith("Well:")){
                    return ["Well", name.substring(5)];
                }
                if (name.startsWith("Port:")){
                    return ["Port", name.substring(5)];
                }
            });
            if (clickable && clickable[0] == "Well"){
                let id = clickable[1];
                let data = await fetch(`/api/getorphanwelldetails/${token.token}/${id}`).then(data => data.json())
                setWellDetails(data.well)
            }
            if (clickable && clickable[0] == "Port"){
                setDisplayPortDetails(false)
                setPortDetails(clickable[1])
            }
        })

        setMap(map);
        setOsm(osm);
        setSat(sattelite)
        setGpxLayer(gpxLayer)
        setStaticLayers(staticLayers);
        setImagesLayer(imagesLayer)
        setOverlays(overlays);
        setAirLayer(airLayer);
        setVisLayer(visLayer);
        setPortsLayer(portsLayer);
        setWellsLayer(wellsLayer);
        setSpotBeamsLayer(spotBeamsLayer)
        setTrackedLayer(trackedLayer);

        return ()=>{
            isMounted = false;
            clearInterval(intervalId)
            map.setTarget(undefined)
        }
    }, []);
    //TODO: Add some dependencies to the map building and separate different layer handling in different effect hooks

    return (
        <div style={{position: "relative", height: "70vh"}}>
            <Modal show={isGeofencePopupVisible} onHide={hideGeofencePopup}>
                <Modal.Header closeButton>
                    <Modal.Title>Save geofence and zone</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form onSubmit={submitGeofence}>
                        <Form.Group>
                            <Form.Label>Geofence zone name</Form.Label>
                            <Form.Control type="text" ref={geoName}/>
                        </Form.Group>
                        <Form.Group>
                            <Form.Label>Geofence zone type</Form.Label>
                            <Form.Select ref={geoType}>
                                <option>Safe</option>
                                <option>Buffer</option>
                                <option>Danger</option>
                                <option>Other</option>
                            </Form.Select>
                        </Form.Group>
                        <Form.Group>
                            <Form.Label>Buffer zone width (in meters)</Form.Label>
                            <Form.Control type="number" defaultValue={10} ref={geoBufSize}/>
                        </Form.Group>
                    </Form>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={hideGeofencePopup}>
                        Close
                    </Button>
                    <Button variant="primary" onClick={submitGeofence}>
                        Save geofence zone
                    </Button>
                </Modal.Footer>
            </Modal>
            <Modal show={isRegionPopupVisible} onHide={hideRegionPopup}>
                <Modal.Header closeButton>
                    <Modal.Title>Save region</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form onSubmit={submitRegion}>
                        <Form.Group>
                            <Form.Label>Region name</Form.Label>
                            <Form.Control type="text" ref={regName}/>
                        </Form.Group>
                    </Form>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={hideRegionPopup}>
                        Close
                    </Button>
                    <Button variant="primary" onClick={submitRegion}>
                        Save region
                    </Button>
                </Modal.Footer>
            </Modal>
            <Modal show={showSpotBeams && !numSpotBeams} onHide={hideSpotBeams}>
                <Modal.Header closeButton>
                    <Modal.Title>Save region</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form onSubmit={submitShowSpotBeams}>
                        <Form.Group>
                            <Form.Label>Number of spot beams</Form.Label>
                            <Form.Control type="number" ref={numSpotBeamsRef}/>
                        </Form.Group>
                        <Form.Group>
                            <Form.Label>Radius of spot beams (in km)</Form.Label>
                            <Form.Control type="number" ref={spotBeamRadRef}/>
                        </Form.Group>
                    </Form>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={hideSpotBeams}>
                        Close
                    </Button>
                    <Button variant="primary" onClick={submitShowSpotBeams}>
                        Start building spot beams
                    </Button>
                </Modal.Footer>
            </Modal>
            <Modal show={portDetailedInfo && !displayPortDetails} onHide={()=>{setPortDetails(undefined)}}>
                <Modal.Header closeButton>
                    <Modal.Title>Port analytics for {portDetails}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form onSubmit={()=>{setDisplayPortDetails(true)}}>
                        <Form.Group>
                            <Form.Label>From date</Form.Label>
                            <Form.Control defaultValue={getTodayPlus(-4)} type="date" ref={fromDate} required/>
                        </Form.Group>
                        <Form.Group>
                            <Form.Label>To date</Form.Label>
                            <Form.Control defaultValue={getTodayPlus(-1)} type="date" ref={toDate} required/>
                        </Form.Group>
                        <Form.Group>
                            <Form.Label>Produce a csv report</Form.Label>
                            <Form.Check type="checkbox" ref={produceReport}/>
                        </Form.Group>
                    </Form>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={()=>{setPortDetails(undefined)}}>
                        Close
                    </Button>
                    <Button variant="primary" onClick={()=>{setDisplayPortDetails(true)}}>
                        Display port analytics on map
                    </Button>
                </Modal.Footer>
            </Modal>
            <div ref={mapElement} style={{height: "70vh"}}>
            </div>
            {getControls()}
            <div style={{position: "absolute", bottom: "40px", right: "10px"}}>
                {shipsCoveredMessage.map(msg => {
                    return (
                        <p style={{textAlign: "right"}}>{msg}</p>
                    )
                })}
            </div>
        </div>
    )
}